<template>
  <div class="cny-input">
    <el-input
      @blur="formatDetailBudget"
      v-model="innerValue"
      @focus="focusOnPrice"
      :disabled="disabled"
      :placeholder="placeholder"
    ></el-input>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      default: ''
    },
    placeholder: {
      default: ''
    },
    disabled: Boolean,
    valueFixed: {
      default: 0
    }
  },
  data() {
    return {
      isFocus: false,
      innerValue: ''
    };
  },
  computed: {
    valueComputed: {
      get() {
        if (this.isFocus) {
          return this.innerValue;
        } else {
          return this.formatInputPrice(this.value);
        }
      },
      set(val) {
        val = val
          .replace(/([^\d\.]|^0(\d+))/g, '$2')
          .replace(/(\.)(\d*)(\1*)/g, '$1$2')
          .replace(/(\.)(\d{1,2})\d*/g, '$1$2');
        this.$emit('input', val);
      }
    }
  },
  watch: {
    value(value) {
      //   console.log('cnyinput watch+++', value);
      this.innerValue = this.formatInputPrice(value);
      //   console.log('cnyinput this.innerValue+++', this.innerValue);
    }
  },
  mounted() {
    this.innerValue = this.formatInputPrice(this.value);
  },
  methods: {
    focusOnPrice() {
      this.isFocus = true;
      this.innerValue = this.innerValue.toString().replaceAll(',', '');
    },
    formatDetailBudget() {
      let str = this.innerValue + '';
      let strTemp = str.replace(/\.$/, '');
      if (str !== strTemp) {
        this.innerValue = strTemp;
      }

      this.innerValue = this.formatInputPrice(strTemp);

      let output = this.innerValue.toString().replaceAll(',', '');
      output = !isNaN(Number(output)) ? Number(output) : '';
      this.$emit('input', output);
      this.$emit('blur', output);
      this.isFocus = false;
    },
    formatInputPrice(param) {
      param = param.toString().replaceAll(',', '');

      param = isNaN(Number(param)) || !param || param === '' ? 0 : param;

      param = param.toString().replace(/[^\d.]/g, '');

      // 必须保证第一个为数字而不是.
      param = param.toString().replace(/^\./g, '');
      // 保证只有出现一个.而没有多个.
      param = param.toString().replace(/\.{2,}/g, '');
      // 保证.只出现一次，而不能出现两次以上
      param = param
        .toString()
        .replace('.', '$#$')
        .replace(/\./g, '')
        .replace('$#$', '.');

      return this.formatPrice(param);
    },
    formatPrice: function (param) {
      if (param) {
        const result = parseFloat(param)
          .toFixed(this.valueFixed)
          .toString()
          .replace(/\d{1,3}(?=(\d{3})+(\.\d*)?$)/g, '$&,');
        return result;
      } else {
        return '0.00';
      }
    }
  }
};
</script>
<style lang="less" scoped></style>



// WEBPACK FOOTER //
// CNYInput.vue?da857dc4